import React from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import { Checkbox, FormControlLabel } from '@mui/material';
import { CheckboxProps } from '@mui/material/Checkbox/Checkbox';

type CheckboxFieldProps = {
  controllerInitialState: UseControllerProps<any>;
  label: string;
} & CheckboxProps;

export const CheckboxField = ({ label, controllerInitialState, ...rest }: CheckboxFieldProps) => {
  const {
    field: { value, onChange },
  } = useController(controllerInitialState);

  return <FormControlLabel control={<Checkbox {...rest} checked={value} onChange={onChange} />} label={label} />;
};
